import { PromoCode } from './promocode';

export class User {

    user_reg_id: number;
    firstName: string;
    lastName: String;
    emailAddress: String;
    mobileNumber: String;
    gender: String;
    password: String;
    dob: String;
    age: String;
    pinCode: String;
    postalAddress: String;
    middleName: String;
    selectedPincode: String;
    bloodGroup: String;
    status: boolean;
    planID: number;
    enabled: boolean;
    role: String;
    transcationalpassword: String;
    userRefCode: String;
    usedRefCode: String;
    planStatus:String;
    passwordchange:string;
    confirmpassword:string;
    profileImgPath:string;
    plan_expire_date:string;
    address:string;
    healthHistory:String;
    healthcardpath:string
    emergencyConatctNo:string;
    emergencyName:string;
    // doctor:Doctor;

    photo:string;
    speciality:string;
    degree:string;
    regno:string;
    gstno:string;
    panno:string;
    aadharCard:string;
    yearofcommencement:string;
    remark:string;
    aadharno:string;
    otp:string;
    other:string;
    degreeCertificatePath:string;
    regnoCertificatePath:string;
    doctorStatusActive:boolean;
    created_date:string;
    pollicyName:string;
    policyDetails:string;
    healthcardPageOnePath:string;
    healthcardPageTwoPath:string;
    personalEmailId:string;
    base64String:string;
    healthCardIssueText:string;
    healthCardIssueReferalText:string;
    healthCardBackSideText:string;
    userPaymentStatus:string;
    promoCode:PromoCode;
    user_status:boolean;

    constructor() {
    }

}
 export class Doctor{
          photo:string;
          speciality:string;
          degree:string;
          regno:string;
          gstno:string;
          panno:string;
          aadharCard:string;
          yearOfcommencement:string;
          remark:string;
          degreeCertificatePath:string;
          regnoCertificatePath:string;
          create_new_subscriber_status:boolean
        }
export class SessionUser{
    user_reg_id: number;
    firstName: string;
    lastName: String;
    mobileNumber: String;
    role: String;
    profileImgPath:string;
    emailAddress:string;

    
    // doctor:Doctor;
}

export class UserDTO{
      user:SessionUser;
	  token:string;
	  plandata:string;
      per:number;
}